<template>
  <div id="app">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background:transparent;
}
a.white {
color: #c0504d;
}
a.white:hover {
color: white;
}
body {
  background-color: #77933c !important;     
  margin: 0;
  padding: 0;
}

/* #77933c */

.page {
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  background-position-y: 50%;
  height: 100%;
  width: 100%;
  display: flex;
  overflow-y: auto;
  font-size: 16px;
}

.location-page {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 420px) minmax(0, 600px);
  grid-template-rows: auto auto;
  align-content: start;
  justify-content: center;
  gap: 16px 20px;
  padding: 20px;
}
.location-page > .locations-white {
  grid-column: 1;
  grid-row: 1;
}
.location-page > .locations-green {
  grid-column: 1;
  grid-row: 2;
}
.location-page > .locations-generic {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
}
.location-page > iframe {
  grid-column: 2;
  grid-row: 1 / span 2;
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 4 / 3;
}
@media screen and (max-width: 768px) {
  .location-page {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto auto auto;
  }
  .location-page > .locations-white,
  .location-page > .locations-green,
  .location-page > iframe {
    grid-column: 1;
    grid-row: auto;
  }
}

.locations-white {
  background: rgba(255, 255, 255, .8);
  border: 1px black solid;
  color: black;
}

.locations-green {
  background: rgba(119,147,60,.8);
  color: white;
  margin-bottom: 20px;
}

.locations-grey {
  background: rgba(82, 86, 89, .8);
  color: white;
}

.locations-generic {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  width: 400px;
  max-width: 90%;
}
.locations-title {
  font-size: 28px;
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
}
h3 {
  font-family: 'Merriweather', serif;  
}
.centered-box {
  width: 75%;
  align-self: center;
}
@media screen and (max-width: 768px) {
  .centered-box {
    width: 90%;
  }
}
@media screen and (max-width: 768px) {
  .page {
    font-size: 17px;
  }
  .centered-box {
    box-sizing: border-box;
    width: calc(100% - 24px);
  }
  .locations-generic {
    padding: 14px;
  }
}
</style>
